import { Component, OnInit, Input } from '@angular/core';
import { ErrorHandlerService } from 'src/app/core/framework/error-handler.service';
import { ToasterService } from 'src/app/core/framework/toaster/toaster.service';
import { DateTimeUtil } from 'src/app/core/framework/utils/date-time-util';
import { AssinaturaDigitalEventoService } from 'src/app/seguranca/configuracao/assinatura-digital/assinatura-digital-evento/assinatura-digital-evento.service';
import { AssinaturaDigitalEvento } from 'src/app/seguranca/configuracao/assinatura-digital/assinatura-digital-evento/model/assinatura-digital-evento.model';
import { AssinaturaDigitalUtil } from 'src/app/seguranca/configuracao/assinatura-digital/util/assinatura-digital.util';


@Component({
  selector: 'app-assinatura-digital-download-de-conteudo',
  templateUrl: './assinatura-digital-download-de-conteudo.component.html',
  styleUrls: ['./assinatura-digital-download-de-conteudo.component.css']
})
export class AssinaturaDigitalDownloadDeConteudoComponent implements OnInit {


  @Input() idAssinaturaDigitalEvento: number = null;

  public assinaturaDigitalEvento: AssinaturaDigitalEvento = null;

  private dateTimeUtil: DateTimeUtil = null;

  constructor(
    private assinaturaDigitalEventoService: AssinaturaDigitalEventoService
    , private errorHandlerService: ErrorHandlerService
    , private toasterService: ToasterService
  ) {
    this.dateTimeUtil = new DateTimeUtil();
  }


  ngOnInit(): void {
    this.carregarDados();
  }

  private carregarDados(): void {
    if ( !this.idAssinaturaDigitalEvento ) {
      return;
    }

    this.assinaturaDigitalEventoService
        .fetch( this.idAssinaturaDigitalEvento )
        .subscribe(o => this.assinaturaDigitalEvento = o);
  }

  public salvarConteudoAssinado(): void {
    const filename = `conteudo_assinado_id_${this.assinaturaDigitalEvento.id}_${this.dateTimeUtil.dateTimeToIsoFormat(new Date())}`.replace(' ', '_');
    this.serveTextFile(this.assinaturaDigitalEvento.conteudoAssinado, filename);
  }

  public salvarConteudoOriginal(): void {
    if ( this.assinaturaDigitalEvento.descricaoConteudoOriginal.toLocaleLowerCase().endsWith('.pdf') ) {
      this.abrirPdfEmNovaAba(this.assinaturaDigitalEvento.conteudoOriginal, this.assinaturaDigitalEvento.descricaoConteudoOriginal);
    }
    else {
      const filename = `conteudo_original_id_${this.assinaturaDigitalEvento.id}_${this.dateTimeUtil.dateTimeToIsoFormat(new Date())}`.replace(' ', '_');
      this.serveTextFile(this.assinaturaDigitalEvento.conteudoOriginal, filename);
    }
  }

  public abrirPdfAssinado() {
    try {
      const pdfBase64 = AssinaturaDigitalUtil.extrairPdfDoJsonAssinadoPelaEVAL(this.assinaturaDigitalEvento.conteudoAssinado);
      const filename = `pdf_assinado_id_${this.assinaturaDigitalEvento.id}_${this.dateTimeUtil.dateTimeToIsoFormat(new Date())}`.replace(' ', '_');
      this.abrirPdfEmNovaAba(pdfBase64, filename);
    }
    catch(e) {
      this.errorHandlerService.handle(e);
    }
  }

  private abrirPdfEmNovaAba(text, downloadAs): void {
    if ( !text ) {
      this.toasterService.error('Não foi possível gerar o PDF');
      return;
    }

    // The Base64 string of a simple PDF file
    const b64 = text;

    var bin = atob(b64);
    // console.log('File Size:', Math.round(bin.length / 1024), 'KB');
    // console.log('PDF Version:', bin.match(/^.PDF-([0-9.]+)/)[1]);
    // console.log('Create Date:', bin.match(/<xmp:CreateDate>(.+?)<\/xmp:CreateDate>/)[1]);
    // console.log('Modify Date:', bin.match(/<xmp:ModifyDate>(.+?)<\/xmp:ModifyDate>/)[1]);
    // console.log('Creator Tool:', bin.match(/<xmp:CreatorTool>(.+?)<\/xmp:CreatorTool>/)[1]);

    // Embed the PDF into the HTML page and show it to the user
    var obj = document.createElement('object');
    obj.style.width = '100%';
    obj.style.height = '842pt';
    obj.type = 'application/pdf';
    obj.data = 'data:application/pdf;base64,' + b64;

    const pdfWindow = window.open('', '_blank', 'resizable=yes, toolbar=no, scrollbars=no, menubar=no, status=no, directories=no, location=no, width=1000, height=600, left=10, top=10');
    pdfWindow.document.body.appendChild(obj);

    if ( downloadAs ) {
      pdfWindow.document.title = downloadAs + '.pdf';
    }

    pdfWindow.focus();
  }

  private serveTextFile(text, downloadAs) {
    const blob = new Blob([text], { type: "text/plain"});
    const url = URL.createObjectURL(blob);

    const domNode = document.createElement('a');
    downloadAs && (domNode.download = downloadAs);
    !downloadAs && (domNode.target = "_blank");
    domNode.href = url;
    domNode.style.display = 'none';
    document.body.appendChild(domNode);
    domNode.click();
    document.body.removeChild(domNode);
  }

}
